<script setup>
import { useSeoMeta } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import { useServiceStore } from '@stores/service'

import Hero from '@sections/services/Hero.vue'
import Services from '@sections/services/Services.vue'
import TearDivider from '@components/global/accents/TearDivider.vue'
import Clients from '@sections/global/Clients.vue'
import Contact from '@sections/global/Contact.vue'
import Loading from '@components/global/Loading.vue'

const global = useGlobalStore()
const service = useServiceStore()

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'services')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'services')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'services')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<Loading v-if="service.categories.length === 0 || !global.clients.length" />
	<main v-else>
		<Hero />
		<Services />
		<TearDivider paper="#080808" background="#111111" />
		<Clients />
		<Contact />
	</main>
</template>
